import {
  Component,
  effect,
  OnDestroy,
  ChangeDetectorRef,
  AfterContentChecked,
  signal,
  input,
  model,
} from '@angular/core';
import { ChatService } from './chat.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DTO, Types } from 'shared-lib';
import { LoadingService } from '../../loading/loading.service';
import { AuthService } from '../../auth/auth.service';
import { RelativeDatePipe } from '../../../pipes';

@Component({
  selector: 'ui-chat',
  standalone: true,
  imports: [CommonModule, FormsModule, RelativeDatePipe],
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
})
export class ChatComponent implements OnDestroy, AfterContentChecked {

  contact = input.required<DTO.ContactDTO>();
  newContact = input.required<(data: DTO.ContactDTO[]) => void>();
  newMessage =
    input.required<(data: DTO.ChatEventDTO<DTO.MessagesDTO>) => void>();
  messages = signal<DTO.MessagesDTO[] | undefined>(undefined);
  isContactTyping = signal<boolean>(false);
  message = model<string>('');

  typingInterval: any;
  isTyping = false;
  userAvatar: string | null = null;
  currentContact?: number

  constructor(
    private chatService: ChatService,
    private cdref: ChangeDetectorRef,
    private loadingService: LoadingService,
    private authService: AuthService
  ) {
    effect(async () => {
      const contact = this.contact()
      if (contact && contact.id != this.currentContact) {
        this.chatService.disconnectWs();
        this.currentContact = contact.id
        this.chatService.connectWS(this.contact(), this.initChat.bind(this));
      }
    });
  }

  initChat() {
    this.messages.set([]);
    this.isContactTyping.set(false);
    this.message.set('');
    this.chatService.listenMessages(this.listenMessages.bind(this));
    this.chatService.listenNewMessage(this.listenNewMessage.bind(this));
    this.chatService.listenNotificationNewMessage(
      this.listenNotificationNewMessage.bind(this)
    );
    this.chatService.listenNotificationNewContact(
      this.listenNotificationNewContact.bind(this)
    );
    this.chatService.listenTyping(this.listenTyping.bind(this));
    this.chatService.listenForMarkAsRead(this.listenForMarkAsRead.bind(this));
    this.chatService.listenUsersOnline(this.listenUsersOnline.bind(this));
    this.chatService.loadMessages();
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  ngOnDestroy(): void {
    clearInterval(this.typingInterval);
    this.chatService.disconnectWs();
  }

  listenMessages(data: DTO.ChatEventDTO<DTO.MessagesDTO[]>) {
    this.messages.set(data.payload);
    this.chatService.sendRead();
    this.loadingService.stop();
  }

  listenNewMessage(data: DTO.ChatEventDTO<DTO.MessagesDTO>) {
    if (data.meta.sender.id == this.authService.getUser()?.sub) {
      this.messages.update((messages) => {
        return messages?.flatMap((message) => {
          if (message.id == data.payload.id) {
            message.status = Types.EMessageStatus.DELIVERED;
          }
          return message;
        });
      });
    } else if (data.meta.receiver.id == this.authService.getUser()?.sub) {
      data.payload.isOwn = false;
      this.messages.update(this.addMessage(data.payload));
    }
  }

  addMessage(newMessage: DTO.MessagesDTO) {
    return (messages: DTO.MessagesDTO[] | undefined) => {
      if (!messages) {
        return [newMessage];
      }
      const contactExist = messages.filter(
        (contact) => contact.id == newMessage.id
      );
      if (contactExist.length <= 0) {
        return [...messages, newMessage];
      }
      return messages;
    };
  }

  listenNotificationNewMessage(data: DTO.ChatEventDTO<DTO.MessagesDTO>) {
    this.newMessage()(data);
  }

  listenNotificationNewContact(data: DTO.ChatEventDTO<DTO.ContactDTO[]>) {
    this.newContact()(data.payload);
  }

  listenForMarkAsRead(data: DTO.ChatEventDTO<undefined>) {}

  listenUsersOnline(data: DTO.ChatEventDTO<DTO.ContactDTO[]>) {}
  listenTyping(data: DTO.ChatEventDTO<DTO.ContactDTO>) {}
  async getUserAvatar() {
    this.userAvatar = await this.chatService.getUsertAvatar();
  }

  sendTypingEvent() {
    this.isTyping = true;
  }

  sendMessage() {
    const content = this.message().trim();
    if (content && this.contact()) {
      const message: DTO.MessagesDTO = {
        id: Date.now(),
        content,
        createdAt: new Date(),
        type: Types.EMessageType.TEXT,
        status: Types.EMessageStatus.DELIVERED,
        isOwn: true,
      };
      this.chatService.sendMessage(message);
      this.messages.update((messages) =>
        messages ? [...messages, message] : [message]
      );
      this.message.set('');
    }
  }

  handleGoBack() {
    // this.chatService.setSelectedConversation(null);
  }
}
